function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-83131d00-c17b-424e-b1e5-74f7cee0c335",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m16.863,4.696c-3.454,0-6.648,1.552-8.784,4.198l-4.246-.936,3.377,10.663,7.547-8.255-3.716-.819c1.576-1.427,3.63-2.243,5.821-2.243,4.795,0,8.696,3.901,8.696,8.696s-3.901,8.696-8.696,8.696c-.72,0-1.304.584-1.304,1.304s.584,1.304,1.304,1.304c6.233,0,11.304-5.071,11.304-11.304s-5.071-11.304-11.304-11.304Z",
    style: {
      fill: "#e7e7e7"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/Redo.d30b1683ed2cec2eaa3396a8d70102ac.svg";
export { ForwardRef as ReactComponent };